export enum RuntimeState {
  Idle = 'idle',
  Starting = 'starting',
  Playing = 'playing',
  Offline = 'offline',
  Empty = 'empty'
}
